// extracted by mini-css-extract-plugin
export default {"container":"_5af83b6d","rating":"_c4e3e7cd","ratingRedesign":"_1a3d3948","noReviews":"_78336862","noReviewsRedesign":"_70394a07"};